<template>
  <AppLayout>
    <VFlex>
      <VCard>
        <VToolbar
          color="white"
          flat
        >
          <VToolbarTitle>{{ currentAgency.name }}</VToolbarTitle>
          <VSpacer />
          <VBtn
            icon
            @click="navigateToSettingsByRole"
          >
            <VIcon>settings</VIcon>
          </VBtn>
        </VToolbar>
      </VCard>

      <AgencyOverviewAgentsTable :agency-id="currentAgency.id" />

      <ContractsTable
        :id="currentAgency.id"
        :is-contracts-of-agencies="true"
      />

      <AgencyOverviewStatements />
    </VFlex>
  </AppLayout>
</template>

<script>
import AgencyOverviewAgentsTable from '@/components/routes/agency/AgencyOverviewAgentsTable'
import ContractsTable from '@/components/routes/agentContracts/ContractsTable'

import { mapGetters } from 'vuex'
import AgencyOverviewStatements from '@/components/routes/agency/AgencyOverviewStatements'

export default {
  name: 'AgenciesOverview',
  components: { AgencyOverviewStatements, ContractsTable, AgencyOverviewAgentsTable },
  computed: {
    ...mapGetters('agency', ['currentAgency'])
  },
  methods: {
    navigateToSettingsByRole () {
      if (this.$can('enterRoute', 'agencySettings.admin')) {
        this.$router.push({ name: 'agencySettings.admin' })
      } else {
        this.$router.push({ name: 'agencySettings' })
      }
    }
  }
}
</script>
